export default __webpack_public_path__ + "_/_/node_modules/ui-header/src/images/lc-logo-blue-139e01e0fa4cfcc6dbc13a7d3f953f2b.svg";